import React from "react";

const DegreeCertImp = () => {
  return (
    <div className="birthImpDocContainer">
      <h2>
        Importance of Degree Certificate <span>Attestation</span> in Bangalore
      </h2>
      <p>Degree certificate attestation serves several essential purposes:</p>
      <div className="marriageImpDocContent">
        <ul>
          <li>
            <span>Higher Education Abroad:</span> Universities in foreign
            countries require attested degree certificates to verify the
            authenticity of an applicant’s academic qualifications.
          </li>
          <li>
            <span>Employment Overseas:</span> Employers in other countries need
            attested degree certificates to confirm the educational background
            of potential employees.
          </li>
          <li>
            <span>Migration and Visa Applications:</span> Attested degree
            certificates are necessary for visa applications to ensure that the
            educational credentials presented are legitimate.
          </li>
          <li>
            <span>Professional Licensing:</span> Many professions, including
            medicine, engineering, and law, require attested degree certificates
            for obtaining licenses to practice abroad.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DegreeCertImp;
